export const SCREEN_STYLING_CONSTANTS = {
  GRID_RATIOS: {
    COLLAPSED: '10fr 0fr 0fr',
    EXPANDED: '7fr 0fr 3fr'
  },
  SIDEBAR_ANIMATION_DURATION: '0.3s'
}

/**
 * Statuses for Case Investigation Manager screen
 * @type {{statuses: *[]}}
 */
export const CASE_INVESTIGATION_STATUS = {
  OPEN: 'OPEN',
  UNDER_REVIEW: 'UNDER_REVIEW',
  PENDING_REVIEW: 'PENDING_REVIEW',
  CLOSED: 'CLOSED'
};

/**
 * Default filters for Case Investigation Manager screen
 * @type {{statuses: *[]}}
 */
export const CASE_INVESTIGATION_DEFAULT_FILTERS = {
  statuses: [
    CASE_INVESTIGATION_STATUS.OPEN
  ],
};

export const CASE_INVESTIGATION_CONNECTED_USER_TYPE_ROLE = {
  VICTIM: 'VICTIM',
  SUSPECT: 'SUSPECT'
}

export const CASE_INVESTIGATION_CONNECTED_USER_TYPE = {
  EXTERNAL: 'EXTERNAL',
  ASPORA: 'ASPORA'
}